<template>
  <b-container>
  </b-container>
</template>

<script>

export default {
  name: "Delivery",
}
</script>

<style scoped>

</style>